import React, { useEffect, useState } from "react";

import DFRadScheduleEditor from "./b0023-df-rad-schedule-editor";

import { RadiSchedulerService } from "../../model/backoffice/df-ratio";
import { GetThaiZoneDate } from "../../core/Helper";

import { useSelector } from "react-redux";
import styled from "styled-components";

import { DefaultEditorValue, GetEditorForm } from "../../core/Helper2";
import MyCalendar from "../../core/MyCalendar";

export default function DfRadScheduler(props) {
  const user = useSelector((s) => s.user);
  const [editor, setEditor] = props.editor;
  const [scheduleWin, setScheduleWin] = useState(DefaultEditorValue);
  const [form, setForm] = useState(null);
  const [events, setEvents] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editor?.show) {
      updateForm();
    }
    return () => {
      setForm(null);
      setScheduleWin(DefaultEditorValue);
    };
  }, [editor?.show]);

  const onDayClick = (item, curDate) => {
    setScheduleWin((pv) => ({
      ...pv,
      show: true,
      item,
      curDate,
      action: (curDate) => {
        setScheduleWin((pv) => ({ ...pv, show: false }));
        //loadAllMonth();
      },
    }));
  };

  const onCalendarChanged = (curDate) => {
    setScheduleWin((pv) => ({ ...pv, curDate }));
    //loadAllMonth(curDate);
  };

  const loadAllMonth = async (curDate) => {
    setLoading(true);
    var ret = await RadiSchedulerService.GetList(
      { schedule_date: createDate(curDate ?? scheduleWin?.curDate) },
      user.detail
    );
    buildEvents(ret, curDate);
    setLoading(false);
  };

  // สร้าง Events ที่จะแสดงบน Calendar
  const buildEvents = (ret, curDate) => {
    let eventList = [];
    let lastDutyType = 0;
    let lastDay = 0;

    ret?.map((item) => {
      let aDay = GetThaiZoneDate(item?.EventDate).getDate();

      if (lastDay !== aDay) {
        lastDutyType = 0;
        lastDay = aDay;
      }

      if (lastDutyType !== item.DutyType) {
        lastDutyType = item.DutyType;
        let headerText = "เช้า";
        switch (lastDutyType) {
          case 1:
            headerText = "เช้า";
            break;
          case 2:
            headerText = "บ่าย";
            break;
          case 3:
            headerText = "ดึก";
            break;
          case 4:
            headerText = "ดึก-2";
            break;
          default:
            headerText = "เช้า";
            break;
        }

        eventList.push({
          event_date: { day: aDay },
          event_text: <DivDuty>{`เวร${headerText}`}</DivDuty>,
        });
      }

      //
      eventList.push({
        event_date: { day: aDay },
        event_text: <DivDutyItem>{item?.FullName}</DivDutyItem>,
      });
    });

    setEvents(eventList);
  };

  useEffect(() => {
    updateForm();
  }, [events, scheduleWin, loading]);

  useEffect(() => {
    if (!scheduleWin?.show) {
      loadAllMonth();
    }
  }, [scheduleWin]);

  const updateForm = () => {
    setForm(
      <div>
        <MyCalendar
          {...{
            events: [events, setEvents],
            onDayClick,
            onCalendarChanged,
            loading: [loading, setLoading],
          }}
        />
      </div>
    );
  };

  const createDate = (curDate) => {
    if (curDate == null) return GetThaiZoneDate(new Date());
    let date = GetThaiZoneDate(curDate.date);
    return date;
  };

  return (
    <>
      <GetEditorForm
        {...{
          title: "จัดการตารางเวร รังสีแพทย์",
          size: "xl",
          form: [form, setForm],
          editor: [editor, setEditor],
          fullscreen: true,
        }}
      />
      <DFRadScheduleEditor {...{ editor: [scheduleWin, setScheduleWin] }} />
    </>
  );
}

const DivDuty = styled.div`
  display: flex;

  justify-content: center;
  color: var(--caption-fore-color);
  border-radius: 5px;
  padding-block: 5px;
  font-style: italic;
  border-bottom: 1px solid var(--bg-primary);
`;

const DivDutyItem = styled.div`
  padding-block: 5px;
  padding-inline-start: 10px;
  color: var(--btn-forecolor);
`;
